// extracted by mini-css-extract-plugin
export var aboveInput = "_m3-0";
export var actionButton = "_m3-5";
export var actionButtonContainer = "_m3-1";
export var actionIcon = "_m3-6";
export var aiInfoContainer = "_m3-2";
export var attachmentWrapper = "_m3-7";
export var bold = "_m3-3";
export var checkIcon = "_m3-8";
export var clickingRecipientBar = "_m3-11";
export var commentThreadSwitch = "_m3-a";
export var draftImage = "_m3-b";
export var draftImageContainer = "_m3-c";
export var draftImages = "_m3-e";
export var editButton = "_m3-g";
export var editor = "_m3-f";
export var editorContainer = "_m3-y";
export var editorErrorTooltipWrapper = "_m3-9";
export var headerDivider = "_m3-h";
export var icon = "_m3-i";
export var info = "_m3-j";
export var internal = "_m3-n";
export var internalDivider = "_m3-k";
export var internalMessage = "_m3-l";
export var messageInputCard = "_m3-m";
export var messageInputForm = "_m3-o";
export var messageInputFormInternal = "_m3-p";
export var options = "_m3-q";
export var publicMessageCustomer = "_m3-s";
export var publicMessageMerchant = "_m3-r";
export var removeImageButton = "_m3-d";
export var replyButtons = "_m3-t";
export var showSignatureButton = "_m3-u";
export var spinner = "_m3-v";
export var verticalButtonDivider = "_m3-4";
export var visibilitySelector = "_m3-w";
export var warning = "_m3-x";
export var wrappingText = "_m3-z";
export var writingInternalNoteTopBorder = "_m3-10";